// Termos a ignorar: a LINHA que contem o termo (case-insensitive) e apagada.
// Quem decide se a mensagem ainda vale (sobrou link valido?) e o pipeline.
export const MAX_TERM_LENGTH = 100;
/** Trim, descarta vazios/longos demais e remove duplicados ignorando caixa. */
export function normalizeTermList(terms) {
    const seen = new Set();
    const out = [];
    for (const raw of terms) {
        const term = raw.trim();
        const key = term.toLowerCase();
        if (term.length === 0 || term.length > MAX_TERM_LENGTH || seen.has(key)) {
            continue;
        }
        seen.add(key);
        out.push(term);
    }
    return out;
}
/** Junta linhas colapsando sequencias de linhas em branco e aparando as bordas. */
export function joinCollapsed(lines) {
    const out = [];
    for (const line of lines) {
        const blank = line.trim().length === 0;
        if (blank && (out.length === 0 || out[out.length - 1].trim().length === 0)) {
            continue;
        }
        out.push(line);
    }
    while (out.length > 0 && out[out.length - 1].trim().length === 0) {
        out.pop();
    }
    return out.join("\n");
}
/** Remove toda linha que contenha algum termo (case-insensitive). */
export function applyIgnoredTerms(text, terms) {
    const lowered = terms
        .map((t) => ({ term: t, key: t.toLowerCase() }))
        .filter((t) => t.key.length > 0);
    if (lowered.length === 0) {
        return { text, removed: [] };
    }
    const removed = [];
    const kept = [];
    text.split(/\r?\n/).forEach((line, index) => {
        const haystack = line.toLowerCase();
        const hit = lowered.find((t) => haystack.includes(t.key));
        if (hit) {
            removed.push({ index, line, term: hit.term });
            return;
        }
        kept.push(line);
    });
    if (removed.length === 0) {
        return { text, removed };
    }
    return { text: joinCollapsed(kept), removed };
}
//# sourceMappingURL=terms.js.map